import React from 'react';
import { useIntl } from 'react-intl';
import importAllImg from "../helpers/import-all-imgs";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));

function NewNews() {
  const { formatMessage } = useIntl();
  const fm = id => formatMessage({id});

  const newsItems = [
    {
      image: 'image 2256.png',
      category: 'podcast',
      publisherKey: 'VIETSUCCESS',
      titleKey: 'Mindful Leadership: Lãnh đạo tự tại phải bắt đầu từ "buông"',
      url: 'https://www.youtube.com/watch?v=yAZ0f1FaIVg',
      actionKey: 'Watch Now →'
    },
    {
      image: 'image 2260.png',
      category: 'news',
      publisherKey: 'Living Heritage',
      titleKey: 'NHÂN VẬT & DI SẢN',
      url: 'https://livingheritage.vn/nguyen-phuong-lam.html',
      actionKey: 'Read More →'
    },
    {
      image: 'image 2261.png',
      category: 'podcast',
      publisherKey: 'Vietnam Innovators Digest',
      titleKey: 'Tại sao tiền không phải là mục tiêu? | Dive with Cát Thảo #5',
      url: 'https://www.youtube.com/watch?v=04hECNunYWs',
      actionKey: 'Watch Now →'
    },
    {
      image: 'image 2263.png',
      category: 'news',
      publisherKey: 'Fulbright University Vietnam',
      titleKey: 'Inspiring Vietnam 2025: Young Voices Shine Through Short Films',
      url: 'https://fulbright.edu.vn/dau-an-noi-bat-tren-chang-duong-ton-vinh-phim-ngan-va-du-an-dien-anh-tre-vi-cong-dong-tai-inspiring-vietnam-2025-copy/',
      actionKey: 'Read More →'
    },
    {
      image: 'image 2266.png',
      category: 'news',
      publisherKey: 'Báo Người Lao Động',
      titleKey: '"Inspiring Vietnam 2025", khi phim ngắn trở thành tiếng nói của thế hệ trẻ',
      url: 'https://nld.com.vn/inspiring-vietnam-2025-khi-phim-ngan-tro-thanh-tieng-noi-cua-the-he-tre-196250915073052492.htm',
      actionKey: 'Read More →'
    },
    {
      image: 'image 2265.png',
      category: 'news',
      publisherKey: 'KEARNEY',
      titleKey: 'The rising tide of cross-border philanthropy in Asia',
      url: 'https://www.kearney.com/service/sustainability/article/the-rising-tide-of-cross-border-philanthropy-in-asia',
      actionKey: 'Read More →'
    },
    {
      image: 'image 21791.png',
      category: 'news',
      publisherKey: 'Fulbright University Vietnam',
      titleKey: 'Changing the world from the smallest & most genuine gestures',
      url: 'https://fulbright.edu.vn/vi/nguyen-phuong-lam-scholarship-fulbright-university-vietnam-philanthropy-acumen-academy/',
      actionKey: 'Read More →'
    },
    {
      image: 'image 21731.png',
      category: 'news',
      publisherKey: 'The Business Times',
      titleKey: 'When empathy meets philanthropy',
      url: 'https://www.businesstimes.com.sg/wealth-december-2018/when-empathy-meets-philanthropy',
      actionKey: 'Read More →'
    },
    {
      image: 'image 21801.png',
      category: 'news',
      publisherKey: 'Fulbright University Vietnam',
      titleKey: '"Intention is more important than action"',
      url: 'https://fulbright.edu.vn/intention-is-more-important-than-action-a-lesson-on-how-social-businesses-can-create-positive-impacts-for-society/',
      actionKey: 'Read More →'
    },
    {

      image: 'image 2177.png',
      category: 'news',
      publisherKey: 'DBS Private Bank',
      titleKey: 'Driving Social Impact – An Interview with Mr Lam',
      url: 'https://www.dbs.com.sg/private-banking/articles/esg/wheels-in-motion',
      actionKey: 'Read More →'
    },
    {
      image: 'image 21811.png',
      category: 'news',
      publisherKey: 'Fulbright University Vietnam',
      titleKey: 'Fulbright University Vietnam and VIETSEEDS Foundation announce',
      url: 'https://fulbright.edu.vn/fulbright-university-vietnam-and-vietseeds-foundation-announce-new-np-family-scholarship-for-incoming-student/',
      actionKey: 'Read More →'
    },
    {
      image: 'image 2267.png',
      category: 'news',
      publisherKey: 'The Business Times',
      titleKey: 'The changing face of philanthropy',
      url: 'https://www.businesstimes.com.sg/wealth/wealth-investing/whos-who-private-banking-july-2019/changing-face-philanthropy',
      actionKey: 'Read More →'
    }
  ];

  return (
    <div>
      {/* Header Section - Mobile */}
      <div className="block md:hidden mt-[50px] bg-[#354402] py-6 px-[5%]">
        <div className="font-['Bebas_Neue'] text-white text-2xl mb-2">
          {fm('NEWS')}
        </div>
        <div className="text-white text-base">
          {fm('Stories that showcase our projects and collaborations with Changemakers across Asia.')}
        </div>
      </div>

      {/* Header Section - Desktop */}
      <div className="hidden md:block mt-[90px] bg-[#354402] py-10 px-[7.5%]">
        <div className="font-['Bebas_Neue'] text-white text-[50px] mb-2">
          {fm('IN THE NEWS')}
        </div>
        <div className="text-white text-lg max-w-[521px]">
          {fm('Stories that showcase our projects and collaborations with Changemakers across Asia.')}
        </div>
      </div>

      {/* Grid Section */}
      <div className="bg-[#F5F4EE] py-8 md:py-12 px-[15%] md:px-[7.5%]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6">
          {newsItems.map((item, index) => (
            <div
              key={index}
              className=" rounded-2xl overflow-hidden flex flex-col cursor-pointer hover:shadow-lg transition-shadow"
              onClick={() => window.open(item.url, '_blank')}
            >
              {/* Image */}
              <div className="relative w-full aspect-square overflow-hidden">
                <img
                  src={imgs[item.image]}
                  alt={fm(item.titleKey)}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="p-4 flex-1 flex flex-col">
                {/* Category and Publisher */}
                <div className="flex items-center gap-2 mb-2">
                  <img
                    src={imgs[item.category === 'podcast' ? 'podcast-svgrepo-com 2.png' : 'news-svgrepo-com 9.png']}
                    alt={item.category}
                  />
                  <span className="text-xs font-bold text-black ">
                    {item.category === 'podcast' ? fm('Podcast') : fm('News')}
                  </span>
                </div>

                {/* Publisher */}
                <div className="text-sm font-bold text-black mb-2">
                  {fm(item.publisherKey)}
                </div>

                {/* Title */}
                <h3 className="text-sm font-semibold text-black mb-3 flex-1 leading-tight">
                  {fm(item.titleKey)}
                </h3>

                {/* Action Link */}
                <div
                  className="text-sm font-bold text-[#354402] hover:text-[#6b8804] transition-colors"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(item.url, '_blank');
                  }}
                >
                  {fm(item.actionKey)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default NewNews;
